import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Util } from "../../helpers/util";

import { updateModal } from "../../store/modal/modal.action";
import backicon from "../Assets/backicon.svg";
import closeicon from "../Assets/close-icon.svg";

import "./modal.css";

const LocalModal = ({
  show,
  onCloseClick,
  children,
  dim,
  updateModal,
  name = "modal-no-name",
  ...props
}) => {
  const { show: prevShow } = props[name] || {};
  useEffect(() => {
    if (prevShow !== show) {
      updateModal({ [name]: { show, onCloseClick, children, dim } });
    }

    return () => {
      if (prevShow) {
        updateModal({
          [name]: { show: false, onCloseClick: Util.noop, children: [] },
        });
      }
    };
  }, [prevShow, show, onCloseClick, children, updateModal, name, dim]);

  return null;
};

export const Modal = connect((state) => state.modal, {
  updateModal,
})(LocalModal);

const LocalModalContainer = (props) => {
  const modals = Object.entries(props)
    .filter(([, modal]) => modal.show)
    .map(([key, modal]) => ({ key, ...modal }));

  return modals.map((modal, i) => {
    return (
      <div
        className={`modal-container${modal.dim ? " dim" : ""}`}
        key={`modal-${modal.key}`}
        style={{ zIndex: 999 + i }}
      >
        <div
          className="overlay"
          onClick={modal.onCloseClick || Util.noop}
        ></div>
        {modal.children}
      </div>
    );
  });
};

export const ModalContainer = connect(
  (state) => state.modal,
  null
)(LocalModalContainer);

export const RightCardModalContent = ({
  children,
  onBackClick = Util.noop,
  dim,
}) => {
  return (
    <div className="right-card-content">
      <button className="back-btn" onClick={onBackClick}>
        <img src={backicon} alt="back-icon" className="icon" />
      </button>
      {children}
    </div>
  );
};

export const ModalContentCompact = ({ children }) => {
  return <div className="modal-content-compact">{children}</div>;
};

export const ModalHeader = ({ title, onCloseClick }) => {
  return (
    <div className="modal-header">
      <h2 className="title">{title}</h2>{" "}
      <img src={closeicon} alt="close-icon" />
    </div>
  );
};
